let Values = {
  STRAIGHT_LINE          : 'STRAIGHT_LINE',
  SL_LEFT_FORELIMB_FLEX  : 'SL_LEFT_FORELIMB_FLEX',
  SL_RIGHT_FORELIMB_FLEX : 'SL_RIGHT_FORELIMB_FLEX',
  SL_LEFT_HINDLIMB_FLEX  : 'SL_LEFT_HINDLIMB_FLEX',
  SL_RIGHT_HINDLIMB_FLEX : 'SL_RIGHT_HINDLIMB_FLEX',
  LEFT_CIRCLE            : 'LEFT_CIRCLE',
  RIGHT_CIRCLE           : 'RIGHT_CIRCLE',
  EIGHT                  : 'EIGHT',
  MOUNT                  : 'MOUNT',
  TRACK                  : 'TRACK',
  CUSTOM                 : 'CUSTOM',
  OTHER_MOBILIZATION_TEST: 'OTHER_MOBILIZATION_TEST',
};

export default Object.seal({
  ...Values,

  /* All values */
  values: Object.keys(Values),

  /* Get name for value. */
  name: (value, custom) => {
    switch (value) {

      case Values.STRAIGHT_LINE:
        return 'Ligne Droite';

      case Values.SL_LEFT_FORELIMB_FLEX:
        return 'Ligne Droite - Flexion Antérieur Gauche';

      case Values.SL_RIGHT_FORELIMB_FLEX:
        return 'Ligne Droite - Flexion Antérieur Droit';

      case Values.SL_LEFT_HINDLIMB_FLEX:
        return 'Ligne Droite - Flexion Postérieur Gauche';

      case Values.SL_RIGHT_HINDLIMB_FLEX:
        return 'Ligne Droite - Flexion Postérieur Droit';

      case Values.LEFT_CIRCLE:
        return 'Cercle à Main Gauche';

      case Values.RIGHT_CIRCLE:
        return 'Cercle à Main Droite';

      case Values.EIGHT:
        return 'Huit';

      case Values.MOUNT:
        return 'Monté';

      case Values.TRACK:
        return 'Piste';

      case Values.OTHER_MOBILIZATION_TEST:
        return 'Autre test de mobilisation';

      case Values.CUSTOM:
        return custom;

      default:
        return value;
    }
  },

  /* Get short for value. */
  short: (value, custom) => {
    switch (value) {

      case Values.STRAIGHT_LINE:
        return 'LD';

      case Values.SL_LEFT_FORELIMB_FLEX:
        return 'Flex-AG';

      case Values.SL_RIGHT_FORELIMB_FLEX:
        return 'Flex-AD';

      case Values.SL_LEFT_HINDLIMB_FLEX:
        return 'Flex-PG';

      case Values.SL_RIGHT_HINDLIMB_FLEX:
        return 'Flex-PD';

      case Values.LEFT_CIRCLE:
        return 'CMG';

      case Values.RIGHT_CIRCLE:
        return 'CMD';

      case Values.EIGHT:
        return '8';

      case Values.MOUNT:
        return 'M';

      case Values.TRACK:
        return 'P';

      case Values.OTHER_MOBILIZATION_TEST:
        return 'Autre test mob';

      case Values.CUSTOM:
        return custom;

      default:
        return value;
    }
  }
});
